import gql from 'graphql-tag'

export default gql`

mutation editProjectSupplierInvoice($project_id: String!, $project_activity_budget_id: Int!, $description: String!, $amount: Float!) {
    editProjectSupplierInvoice(project_id: $project_id, project_activity_budget_id: $project_activity_budget_id, description: $description, amount: $amount) @client
}`